import { render } from "./AccessControlState.vue?vue&type=template&id=8be35074"
import script from "./AccessControlState.vue?vue&type=script&lang=js"
export * from "./AccessControlState.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ThesauRex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__